import React from 'react'
import PropTypes from 'prop-types'
import ImageBlock from 'Components/ImageBlock'
import NumberWithCommas from 'Utils/NumberWithCommas'
import SubmitButton from 'Components/SubmitButton'
import ContentStatBlock from 'Components/ContentStatBlock'

const submitButtonClasses = 'p-4 rounded-lg w-full mb-4'
const buttonPrimaryClasses = 'bg-indigo-800'
const buttonSecondaryClasses =
  'border border-indigo-800 text-indigo-800 bg-white'

const LandingPageOverviewPanel = ({
  course,
  joiningInProgress,
  trialJoiningInProgress,
  contentStats,
  goToCourse,
  joinCourse,
  joinTrialClicked,
}) => (
  <div className="w-full max-w-sm">
    <div>
      <ImageBlock
        width="100%"
        height={300}
        alt={course.title}
        className="w-full h-auto rounded-xl shadow-xl mb-8"
        style={{
          zIndex: 100,
          borderRadius: 'inherit',
        }}
        src={course.thumbnail}
      />
    </div>
    {contentStats.nModules > 0 && (
      <div className="block mb-8">
        <div className="grid grid-cols-2 gap-6">
          {/* If no other stat is available => fullwidth module stat 
                  If other stat available => half width module stat */}
          <div
            className={`${
              contentStats.nTests +
                contentStats.nLectures +
                contentStats.nFiles >
              0
                ? 'col-span-1'
                : 'col-span-2'
            }`}
          >
            <ContentStatBlock label="Module" number={contentStats.nModules} />
          </div>
          {contentStats.nTests > 0 && (
            <div className="col-span-1">
              <ContentStatBlock label="Test" number={contentStats.nTests} />
            </div>
          )}
          {contentStats.nLectures > 0 && (
            <div className="col-span-1">
              <ContentStatBlock
                label="Lecture"
                number={contentStats.nLectures}
              />
            </div>
          )}
          {contentStats.nFiles > 0 && (
            <div className="col-span-1">
              <ContentStatBlock label="File" number={contentStats.nFiles} />
            </div>
          )}
        </div>
      </div>
    )}
    {course.roles.isMember ? (
      <>
        <SubmitButton
          color="primary"
          variant="outlined"
          size="large"
          text="GO TO COURSE"
          isValid
          isSubmitting={false}
          onClick={goToCourse}
          bottomSpacing={2}
          className={`${submitButtonClasses} ${buttonPrimaryClasses}`}
        />
        {course.trialData && (
          <SubmitButton
            color="primary"
            variant="contained"
            size="large"
            text={`BUY ₹${NumberWithCommas(course.price)}`}
            isValid
            isSubmitting={joiningInProgress}
            onClick={joinCourse}
            bottomSpacing={0}
            className={`${submitButtonClasses} ${buttonPrimaryClasses}`}
          />
        )}
      </>
    ) : (
      <div>
        {course.plan === 'paid' && (
          <>
            <SubmitButton
              color="primary"
              variant="contained"
              size="large"
              text={`BUY COURSE FOR ₹${NumberWithCommas(course.price)}`}
              isValid
              isSubmitting={joiningInProgress}
              onClick={joinCourse}
              bottomSpacing={2}
              className={`${submitButtonClasses} ${buttonPrimaryClasses}`}
            />
            {course.trialEnabled && (
              <SubmitButton
                color="secondary"
                size="large"
                text={`FREE TRIAL FOR ${course.trialDays} DAY${
                  course.trialDays === 1 ? '' : 'S'
                }`}
                isValid
                isSubmitting={trialJoiningInProgress}
                onClick={joinTrialClicked}
                bottomSpacing={0}
                className={`${submitButtonClasses} ${buttonSecondaryClasses}`}
              />
            )}
          </>
        )}
        {course.plan === 'public' && (
          <div>
            <SubmitButton
              isValid
              isSubmitting={joiningInProgress}
              color="primary"
              variant="contained"
              size="large"
              bottomSpacing={0}
              text="JOIN FOR FREE"
              onClick={joinCourse}
              className={`${submitButtonClasses} ${buttonPrimaryClasses}`}
            />
          </div>
        )}
        {course.plan === 'private' && (
          <div className="text-blue-700 bg-gray-100 text-base p-4 rounded-lg">
            <p className="text-base">
              This is an invite-only course. Please contact the instructor to
              request access.
            </p>
          </div>
        )}
      </div>
    )}
  </div>
)

LandingPageOverviewPanel.propTypes = {
  contentStats: PropTypes.object.isRequired,
  course: PropTypes.object.isRequired,
  joiningInProgress: PropTypes.bool.isRequired,
  trialJoiningInProgress: PropTypes.bool.isRequired,
  goToCourse: PropTypes.func.isRequired,
  joinCourse: PropTypes.func.isRequired,
  joinTrialClicked: PropTypes.func.isRequired,
}

export default LandingPageOverviewPanel
